<template>
  <div  class="action-fab" :class="{open: active}" @click="active = false">
    <upload-file :multiple="true" :parent-id="$route.params && $route.params.id ? parseInt($route.params.id) : null">
      <template slot-scope="props">
        <v-speed-dial
            v-model="active"
            bottom
            right
            fixed
            direction="top"
            transition="slide-y-reverse-transition"
            v-if="actions.length > 0">
          <v-btn slot="activator"
                 class="accent fixed-bottom"
                 dark
                 fab
                 hover
                 v-model="active">
            <v-icon>add</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <div class="fab-action-container">
            <div v-for="(action, index) in actions"
              :key="index"
              class="lefty"
              @click="() => {
                if (action.upload) {
                  upload(props.uploadFile)
                } else {
                  action.action()
                }
                active = false
              }">
              <span class="fab-action-label">{{$tf(action.name)}}</span>
              <v-btn fab dark small class="primary">
                <v-icon>{{action.icon}}</v-icon>
              </v-btn>
            </div>
          </div>
        </v-speed-dial>
      </template>
    </upload-file>
  </div>
</template>

<script>

  export default {
    name: 'actions-fab',
    data () {
      return {
        active: false,
        actions: []
      }
    },
    computed: {
      storeActions () {
        return this.$store.state.actionsTray.actionsFab
      }
    },
    mounted () {
      this.actions = this.$store.state.actionsTray.actionsFab
    },
    watch: {
      storeActions (val) {
        this.actions = val
      }
    },
    methods: {
      upload (method) {
        let usedStorage = this.$store.state.session.usedStorage
        let platformUserLimit = this.$store.state.session.platformUserLimit
        if (this.$store.state.config.premium && usedStorage > platformUserLimit && platformUserLimit > -1) {
          this.$store.dispatch('dialog/showDialog', {
            title: 'No more space left',
            body: require('~/components/common/dialog/types/DialogNoMoreSpace.vue').default,
            persistent: true,
            width: 480,
            actions: {
              cancel: 'Close'
            }
          })
          return
        }
        method()
      }
    }
  }
</script>

<style type="scss" scoped>
  .action-fab {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    transition: background-color 0.5s;
    z-index: 4;
  }

  .open {
    background-color: rgba(255, 255, 255, 0.65);
    pointer-events: all;
  }

  .speed-dial {
    pointer-events: all;
  }

  .fixed-bottom {
    position: absolute;
    bottom: 35px;
    left: -56px;
  }

  .fab-action-container {
    position: absolute;
    right: 75px;
    bottom: 0;
  }

  .lefty {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .fab-action-label {
    background: #616161;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    display: inline-block;
    opacity: 0.9;
    padding: 5px 8px;
    pointer-events: none;
    text-transform: initial;
    width: auto;
    margin-right: 5px;
    white-space: pre;
    z-index: 99;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
    right: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/actions-tray/ActionsFAB.vue